import {css} from "@emotion/css";
import {Alert, AlertTitle} from "@mui/lab";
import ButtonSecondaryRaiko from "../../raikoComponents/raikoButtons/ButtonSecondaryRaiko";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import React from "react";
import PropTypes from "prop-types";

const ConfirmDialog = (
    {
        doAction,
        cancelAction,
        title = " آیا از حذف این آیتم اطمینان دارید ؟!",
        description = "با اتمام حذف امکان بازیابی آن وجود نخواهد داشت !!!",
        confirmButtonTitle = "حذف کن",
        cancelButtonTitle="بیخیال"
    }) => {
    return (
        <section className={css`display: flex;
          flex-direction: column;
          padding: 0 16px 16px 16px;
          overflow-x: hidden !important;
        `}>

            <div className="deleteDialogContainer">

                <Alert severity="warning">
                    <AlertTitle>{title}</AlertTitle>
                    <div className={css`display: flex;
                      flex-direction: column;
                      gap: 8px;
                      margin-top: 16px;
                    `}>
                        {description}
                    </div>
                </Alert>

            </div>

            <div className="d-flex flex-column w-100">

                <div className="deleteDialogButtonContainer">
                    <ButtonSecondaryRaiko onClick={doAction} label={confirmButtonTitle}/>
                    <ButtonPrimaryRaiko onClick={cancelAction} label={cancelButtonTitle}/>
                </div>
            </div>
        </section>
    )
}


export default ConfirmDialog;

ConfirmDialog.propTypes = {
    doAction: PropTypes.func.isRequired,
    cancelAction: PropTypes.func.isRequired,
    title: PropTypes.string,
    description: PropTypes.string,
}